import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {filter, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScriptInjectionStatusService {
  scriptInjectionStatusSubjects: {[key: string]: Subject<boolean>} = {};

  public getScriptInjectionStatus(key: string): Observable<boolean> {
    if (!this.scriptInjectionStatusSubjects[key]) {
      this.scriptInjectionStatusSubjects[key] = new BehaviorSubject<boolean>(false);
    }
    return this.scriptInjectionStatusSubjects[key].asObservable().pipe(
      filter((statusBool) => statusBool),
      take(1)
    );
  }

  public setNewInjectionStatus(key: string, status: boolean = true): void {
    if (!this.scriptInjectionStatusSubjects[key]) {
      this.scriptInjectionStatusSubjects[key] = new BehaviorSubject<boolean>(status);
    } else {
      this.scriptInjectionStatusSubjects[key].next(status);
    }
  }
}
